/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import {
    getAEMContent,
    initiateQuestionnaireDynamicLanding,
    saveRelationshipName,
    resetBankerQuestionnaire,
    resetSelection,
} from '../../redux/actions';
import Loader from '../../atoms/Loader';
import DynamicLanding from '../../molecules/DynamicLanding';
import { productConfiguration } from '../../config';
import { productID } from '../../constants';
import {
    getDPSGeneralReportingData,
    dispatchReportingEvent,
    tealiumUpdatedPageView,
    checkAndSetCorrelationId,
    resetCorrelationId,
    constructAnswerResponse,
} from '../../utils';
import defaultLang from '../../language';
import PageLevelNotification from '../../molecules/PageLevelNotification';

const { aemUrl } = window.__conf__;
const defaultError = [
    {
        link: null,
        linkText: 'relationship name',
        text: 'Enter the ',
    },
];
function DynamicLandingPage() {
    const [errorNotifications, setErrorNotifications] = useState([]);
    const [fieldError, setFieldError] = useState(0);
    const history = useHistory();
    const dispatch = useDispatch();
    const error = useSelector((state) => state.errorReducer.error);
    const answerContainer = useSelector(
        (state) => state.appReducer.answerContainer,
    );

    const sessionID = useSelector(
        (state) => state.dynamicLandingReducer.sessionID,
    );
    const activeQuestionID = useSelector(
        (state) => state.dynamicLandingReducer.activeQuestionID,
    );
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );

    const relationshipName = useSelector(
        (state) => state.dynamicLandingReducer.relationshipName,
    );
    const formFields = useSelector(
        (state) => state.dynamicLandingReducer.formFields,
    );
    const isLoading = useSelector(
        (state) => state.loaderReducer.isLoading,
    );
    const reviewQuestions = useSelector(
        (state) => state.appReducer.reviewQuestions,
    );
    const recommendedProductsLoaded = useSelector(
        (state) =>
            state.recommendationReducer.recommendedResultsLoaded,
    );
    useEffect(() => {
        if (error) {
            if (!sessionID) {
                history.push('/banker/start');
            } else {
                resetCorrelationId();
                history.push('/banker/error');
            }
        }
    }, [error]);

    useEffect(() => {
        checkAndSetCorrelationId();
        dispatch(getAEMContent(productID));
    }, []);

    useEffect(() => {
        const currentPage = defaultLang.siteCat.startPage;
        const answerResponse =
            constructAnswerResponse(answerContainer);
        const reportingData = getDPSGeneralReportingData(
            currentPage,
            null,
            answerResponse,
        );
        dispatchReportingEvent(reportingData);
        tealiumUpdatedPageView();
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (sessionID && activeQuestionID) {
            setErrorNotifications([]);
            history.push(`/banker/questionnaire/${activeQuestionID}`);
        } else if (sessionID && recommendedProductsLoaded) {
            history.push(`/banker/we-have-great-options`);
        } else if (
            sessionID &&
            !activeQuestionID &&
            !reviewQuestions
        ) {
            dispatch(resetBankerQuestionnaire());
        } else if (!sessionID && !reviewQuestions) {
            dispatch(resetSelection());
        }
    }, [sessionID]);

    useEffect(() => {
        const handleSessionTimeOut = () => {
            if (!sessionID) {
                window.history.pushState(
                    null,
                    null,
                    window.location.href,
                );
                window.onpopstate = () => {
                    window.history.go(1);
                };
            }
        };
        handleSessionTimeOut();
        return () => {
            window.onpopstate = null;
        };
    }, []);
    const callErrorScreen = () => {
        history.push('/banker/error');
    };
    function startQuestionnaire(name) {
        // check formfield has any error or not before redirecting it
        if (
            name ||
            (Object.keys(formFields).length > 0 &&
                !formFields.errorCode)
        ) {
            setFieldError(0);
            dispatch(saveRelationshipName(name));
            dispatch(
                initiateQuestionnaireDynamicLanding(
                    productConfiguration['dynamic-business-banking'],
                    callErrorScreen,
                ),
            );
        } else {
            window.scrollTo(0, 0);
            setFieldError(fieldError + 1);
            setErrorNotifications(defaultError);
        }
    }

    const landingPageContent = AEMContent.landingPage.startPageHeader
        ? AEMContent.landingPage
        : defaultLang.landingPageContent;

    return (
        <>
            {isLoading && <Loader />}
            <div className="banker-container-header">
                <Header title={defaultLang.header.fullName} />
                <Helmet>
                    <title>
                        {' '}
                        Getting started | Business Product Selector |
                        U.S. Bank{' '}
                    </title>
                </Helmet>
            </div>
            <main id="app__content" className="get__started">
                <div className="main-left-content">
                    <PageLevelNotification
                        errorNotifications={errorNotifications}
                        handleErrorClick={() => {}}
                    />
                </div>
                <DynamicLanding
                    relationshipName={relationshipName || ''}
                    content={landingPageContent}
                    imageUrl={`${aemUrl}${AEMContent.landingPage.imageUrl}`}
                    handleNextClick={startQuestionnaire}
                    /* goBack={goBack} */
                    fieldError={fieldError}
                />
            </main>
            <div className="banker-container-footer">
                <Footer
                    header={defaultLang.footer.connectionTitle}
                    content={defaultLang.footer.footerDisclosure}
                    privacyLabel={AEMContent.footer.privacyLabel}
                    privacyUrl={AEMContent.footer.privacyUrl}
                    fdic={defaultLang.footer.connectionContent}
                    cobrowseLabel={AEMContent.footer.cobrowseLabel}
                    cobrowseUrl={AEMContent.footer.cobrowseUrl}
                />
            </div>
        </>
    );
}

export default DynamicLandingPage;
